/** @format */

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { DocumentsViewDto } from '../../../Models';
import ViewImage from './ViewImage';
import ViewPdf from './ViewPdf';

interface Props {
  document: DocumentsViewDto;
}
export default function DocumentModal({ document }: Props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderDocument = () => {
    const ext = (document.extension || '').toLowerCase();
    if (ext.includes('image')) {
      return <ViewImage document={document} />;
    }
    if (ext.includes('pdf')) {
      return <ViewPdf document={document} />;
    }
    return (
      <Typography variant='body2' color='text.secondary' sx={{ p: 2 }}>
        A preview is not available for this file type.
      </Typography>
    );
  };

  return (
    <React.Fragment>
      <Link
        component='button'
        type='button'
        variant='body2'
        onClick={handleClickOpen}
        underline='hover'
        sx={{
          fontWeight: 600,
          cursor: 'pointer',
          textAlign: 'center',
          display: 'block',
          width: '100%',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          lineHeight: 1.45,
          py: 0.25,
        }}>
        {document.documentTypeName}
      </Link>

      <Dialog
        sx={{ zIndex: 999999 }}
        open={open}
        fullWidth
        maxWidth='lg'
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'>
        <DialogContent>{renderDocument()}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='error' variant='contained'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
